"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHttpErrorPage_component_exports = {};
__export(GlobalHttpErrorPage_component_exports, {
  GlobalHttpErrorPage: () => GlobalHttpErrorPage
});
module.exports = __toCommonJS(GlobalHttpErrorPage_component_exports);
var import_react = __toESM(require("react"));
var import_react_i18next = require("react-i18next");
var import_i18n = __toESM(require("../../../i18n"));
var import_GlobalHttpErrorPage = require("./GlobalHttpErrorPage.styled");
var import_GlobalHttpErrorPage2 = require("./GlobalHttpErrorPage.constants");
var import_GlobalHttp404ErrorPage = require("./GlobalHttp404ErrorPage/GlobalHttp404ErrorPage.component");
var _excluded = ["errorCodeVariant", "withErrorDetails", "showErrorCode"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var GlobalHttpErrorPage = function GlobalHttpErrorPage2(_ref) {
  var _ref$errorCodeVariant = _ref.errorCodeVariant, errorCodeVariant = _ref$errorCodeVariant === void 0 ? 401 : _ref$errorCodeVariant, _ref$withErrorDetails = _ref.withErrorDetails, withErrorDetails = _ref$withErrorDetails === void 0 ? false : _ref$withErrorDetails, _ref$showErrorCode = _ref.showErrorCode, showErrorCode = _ref$showErrorCode === void 0 ? true : _ref$showErrorCode, props = _objectWithoutProperties(_ref, _excluded);
  var textAreaRef = (0, import_react.useRef)(null);
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var copyTextInTextArea = function copyTextInTextArea2() {
    navigator.clipboard.writeText(props.errorDetails);
  };
  var getButtonsList = function getButtonsList2(alignment, dataTestId) {
    return /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledAllButtonsContainer, {
      alignment,
      "data-testid": dataTestId
    }, props.actions.map(function(buttonDetails) {
      return /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledButton, {
        icon: buttonDetails.icon,
        variant: buttonDetails.variant === "primary" ? "primary" : "ghost",
        onClick: buttonDetails.actionCallback,
        key: buttonDetails.actionMsg
      }, buttonDetails.actionMsg);
    }));
  };
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, errorCodeVariant === 404 ? /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.GlobalHttp404ErrorPage, {
    customErrorMessage: props.customErrorMessage,
    actions: props.actions
  }) : /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledErrorPageContainer, {
    role: "alert"
  }, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledTextAndButtonContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledTextMessageContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledImageBox, {
    alt: "Great Minds",
    src: "https://cdn.digital.greatminds.org/dp-assets/dp-images/GM_squareLogo.svg"
  }), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledHttpErrorMessage, {
    level: 1
  }, props.customErrorMessage || t((0, import_GlobalHttpErrorPage2.errorCodeMessage)(errorCodeVariant))), showErrorCode && /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledHttpErrorCode, {
    level: 2
  }, t("base_errorMessage_errorCode"), " ", errorCodeVariant), props.additionalInstructionsMessage && /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledAdditionalErrorMessage, {
    level: 2
  }, props.additionalInstructionsMessage)), props.actions && props.actions.length > 0 && !withErrorDetails && getButtonsList("left", "errorTextButtons"), withErrorDetails && /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledTextAreaAndCopyButtonContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledTextAreaAndLabelContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledLabel, {
    "aria-label": t("base_errorMessage_errorDetails"),
    htmlFor: "error-details",
    value: t("base_errorMessage_errorDetails")
  }), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledTextArea, {
    tabIndex: 0,
    ref: textAreaRef,
    id: "error-details"
  }, props.errorDetails)), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledCopyButton, {
    onClick: copyTextInTextArea,
    variant: "empty",
    iconSize: 20,
    icon: "content-copy",
    "aria-label": t("base_errorMessage_copyButton_aria")
  }, t("base_action_copy"))), props.actions && props.actions.length > 0 && withErrorDetails && getButtonsList("right", "copyTextButtons")), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttpErrorPage.StyledErrorImage, {
    alt: t("base_constant_error"),
    src: props.errorCustomImage || "https://cdn.digital.greatminds.org/dp-assets/dp-images/error_illustration@2x.png"
  })));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalHttpErrorPage
});
//# sourceMappingURL=GlobalHttpErrorPage.component.js.map